export default __webpack_public_path__ + "static/media/xacademy for DM.ee9d1d67.svg";